@if (showChecklist()) {
  @if (isCollapsed()) {
    <button
      type="button"
      class="practice-onboarding-checklist-fab"
      (click)="toggleCollapsed($event)"
      [disabled]="guidedTourService.isTourActive()"
      [attr.aria-expanded]="false"
      [attr.aria-label]="fabAriaLabel()"
    >
      <i class="fas fa-list-check" aria-hidden="true"></i>
      @if (openCount() > 0) {
        <span class="practice-onboarding-checklist-fab__badge">{{
          openCount()
        }}</span>
      }
    </button>
  } @else {
    <aside
      class="practice-onboarding-checklist"
      aria-labelledby="practice-onboarding-title"
    >
      <div class="practice-onboarding-checklist__header">
        <div class="practice-onboarding-checklist__heading">
          <h2 id="practice-onboarding-title" i18n="@@practiceOnboarding.title">
            First steps
          </h2>
          <p class="practice-onboarding-checklist__progress">
            <span i18n="@@practiceOnboarding.progressLabel">Progress</span>:
            {{ completedCount() }}/{{ totalCount() }}
          </p>
        </div>
        <button
          type="button"
          class="practice-onboarding-checklist__collapse"
          (click)="toggleCollapsed($event)"
          [attr.aria-expanded]="true"
          i18n-aria-label="@@practiceOnboarding.collapseAria"
          aria-label="Collapse checklist"
        >
          <i class="fas fa-chevron-down" aria-hidden="true"></i>
        </button>
      </div>

      <ul class="practice-onboarding-checklist__list">
        @for (item of items(); track item.key) {
          <li>
            <button
              type="button"
              class="practice-onboarding-checklist__item"
              [class.practice-onboarding-checklist__item--done]="
                isCompleted(item.key)
              "
              [disabled]="isCompleted(item.key)"
              (click)="onTaskClick(item)"
            >
              <span
                class="practice-onboarding-checklist__status"
                [attr.aria-hidden]="true"
              >
                @if (isCompleted(item.key)) {
                  <i class="fas fa-check"></i>
                } @else {
                  <i class="far fa-circle"></i>
                }
              </span>
              <span class="practice-onboarding-checklist__label">{{
                item.label
              }}</span>
            </button>

            @if (item.optional && !isCompleted(item.key)) {
              <button
                type="button"
                class="practice-onboarding-checklist__skip"
                (click)="onSkipEmployees($event)"
                i18n="@@practiceOnboarding.skipEmployees"
              >
                Skip
              </button>
            }
          </li>
        }
      </ul>
    </aside>
  }
}
